
export default {
    methods: {
        goToContact(url){
            url = url != undefined ? url : "";
            window.location = "/contact/" + url;
        },
    }
}
